import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/cert',
    name: 'ValidateCertification',
    component: () => import('../views/ValidateCertification/ValidateCertification.vue')
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('../views/Statistics/Statistics.vue')
  },
  {
    path: '/azv-lookup',
    name: 'AZV lookup',
    component: () => import('../views/AzvLookup.vue')
  },
  {
    path: '/vaccine-certification',
    name: 'ValidateCertificationVaccine',
    component: () => import('../views/ValidateCertificationVaccine/ValidateCertificationVaccine.vue')
  },
  {
    path: '/instructions',
    name: 'InstructionsMainView',
    component: () => import('../views/Instructions/InstructionsMainView.vue')
  },
  {
    path: '/recovery-certification',
    name: 'RecoveryCertification',
    component: () => import('../views/RecoveryCertification/RecoveryCertification.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
